<template>
  <div class="main">
    <div class="profileHeader">
      <Profile />
    </div>
    <div class="mainBody">
      <v-card class="card0">
        <h4>Airtime</h4>
        <v-card flat class="card1">
          <small class="net" v-if="network == 'Etisalat'"
            >Select Network : <b>9MOBILE</b></small
          >
          <small class="net" v-else-if="network == 'Airtel'"
            >Select Network : <b>AIRTEL</b></small
          >
          <small class="net" v-else
            >Select Network : <b>{{ network }}</b></small
          >
          <v-card flat class="cardDiv">
            <div @click="Setnetwork('MTN')" class="network">
              <img
                src="../assets/mtn.png"
                alt="teller logo"
                width="70"
                height="65"
              />
            </div>
            <div @click="Setnetwork('GLO')" class="network">
              <img
                src="../assets/glo.png"
                alt="teller logo"
                width="70"
                height="65"
              />
            </div>
            <div @click="Setnetwork('Etisalat')" class="network">
              <img
                src="../assets/9m.png"
                alt="teller logo"
                width="70"
                height="65"
              />
            </div>
            <div @click="Setnetwork('Airtel')" class="network">
              <img
                src="../assets/airtel.png"
                alt="teller logo"
                width="70"
                height="65"
              />
            </div>
          </v-card>
          <v-row>
            <v-col>
              <div class="labelDiv">
                <label><b>Phone number</b></label>
              </div>
              <v-text-field type="number" v-model="phone" outlined>
                <template slot="prepend-inner">
                  <div class="flag">
                    <img
                      src="../assets/flag.png"
                      alt="teller logo"
                      width="35"
                      height="25"
                    />
                    <p class="num">+234</p>
                  </div>
                </template>
              </v-text-field>
              <div class="labelDiv">
                <label><b>Amount</b></label>
              </div>
              <v-text-field type="number" v-model="amount" outlined>
              </v-text-field>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-spacer></v-spacer>
            <div>
              <v-btn
                v-if="phone == '' && amount == ''"
                dark
                class="nextBtn"
                color="blue-grey"
                large
                v-bind="attrs"
                @click="invaildfield()"
              >
                Proceed
              </v-btn>
              <ConfirmAirtime
                v-else
                :phone="phone"
                :amount="amount"
                :network="network"
              />
            </div>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-card>
    </div>
    <div class="Transaction">
      <v-card class="mx-auto card cardv">
        <div class="ImgTrans">
          <div class="trans">
            <h4>Recent Transactions</h4>
            <small @click="navigate('transactionHistory')">see all ></small>
          </div>
        </div>
        <div class="cardRR">
          <RecentTransactions />
        </div>
      </v-card>
    </div>
  </div>
</template>
<script>
import Profile from "../components/profileHeader";
import RecentTransactions from "../components/RecentTransactions";
import ConfirmAirtime from "../components/ConfirmAirtime";

export default {
  metaInfo: {
    title: "Teller/Airtime",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "Teller.ng",
        content:
          "Teller.ng provides online payment settlement system which allows instant money transfer, bill payment, and airtime purchases. It’s safe, reliable and most importantly, hassle-free.Teller helps you to pay your electricity, cable, internet and other bills with ease.  For convenient airtime recharge, funds transfer, bills payments. Making your everyday payment simple, safe and secure.",
      },
    ],
  },
  components: {
    Profile: Profile,
    RecentTransactions,
    ConfirmAirtime,
  },
  data() {
    return {
      network: "MTN",
      amount: "",
      phone: "",
    };
  },
  methods: {
    Setnetwork(payload) {
      this.network = payload;
    },
    navigate(to) {
      this.$router.push({ name: to });
    },
    invaildfield() {
      let payload = {
        status: true,
        message: "Fill out all the required fields",
      };
      this.$store.dispatch("SnackbarFunc", payload);
    },
  },
};
</script>
<style scoped>
.main {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: minmax(90px, auto);
  margin: 0 auto;
  padding: 0px;
  grid-template-areas:
    "profileHeader profileHeader profileHeader"
    "mainBody mainBody Transaction";
}

.profileHeader {
  grid-area: profileHeader;
  background-color: #faedf2;
  border-top-left-radius: 40px;
  height: 100px;
}

.mainBody {
  grid-area: mainBody;
  background-color: #ffffff;
  border-bottom-left-radius: 40px;
  padding: 50px;
  padding-top: 70px;
}
.mainBody h4 {
  color: #ad1684;
  margin-top: 10px;
}
.Transaction {
  grid-area: Transaction;
  background-color: #ffffff;
  padding-right: 20px;
}
.num {
  padding-top: 3px !important;
}
.card {
  margin-top: 50px;
  border-radius: 20px !important;
  height: 550px;
}
.cardTr {
  display: flex;
  align-items: center;
  padding: 15px;
  padding-right: 20px;
  padding-left: 20px;
  height: 100px;
  border-radius: 20px !important;
  margin-right: 20px;
  margin-left: 20px;
}
.bg {
  background-color: rgba(235, 87, 87, 0.2);
}
.bg1 {
  background-color: rgba(187, 107, 217, 0.3);
}
.ImgTrans {
  background-image: url("../assets/Tbg.png");
  height: 140px; /* You must set a specified height */
  background-position: center; /* Center the image */
  background-repeat: no-repeat; /* Do not repeat the image */
  background-size: cover; /* Resize the background image to cover the entire container */
}
.trans {
  display: flex;
  padding-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  justify-content: space-between;
}
.trans h4 {
  color: white;
}
.trans small {
  color: white;
  text-decoration-line: underline;
  cursor: pointer;
}
.card1 {
  display: flex;
  flex-direction: column;
  padding: 30px;
}
.card0 {
  padding: 10px;
  border-radius: 15px !important;
  box-shadow: 0 16px 50px 0 rgba(189, 36, 39, 0.11);
  background-color: #ffffff;
}
.card0 h4 {
  margin-left: 30px;
}
.cardRR {
  height: 400px;
  overflow: scroll;
  padding-bottom: 10px;
}
.cardRR::-webkit-scrollbar {
  display: none !important;
}
.init {
  margin-left: 15px;
}
.cardDiv {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  margin-top: 10px;
  border-radius: 10px !important;
  background-color: rgba(189, 36, 91, 0.1);
}
.network {
  cursor: pointer;
}
.flag {
  display: flex;
  justify-content: center;
}
.flag img {
  margin-right: 3px;
}
.nextBtn {
  background-color: #ad1684 !important;
  border-radius: 10px;
  text-transform: none;
}

@media only screen and (max-width: 1024px) {
  .main {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-auto-rows: minmax(90px, auto);
    margin: 0 auto;
    padding: 0px;
    grid-template-areas:
      "profileHeader profileHeader profileHeader"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody"
      "mainBody mainBody mainBody";
  }
  .Transaction {
    display: none;
  }
  img {
    width: 30px;
    height: 30px;
  }
  .card0 {
    padding: 10px;
    border-radius: 15px !important;
  }
  .mainBody {
    grid-area: mainBody;
    background-color: #ffffff;
    border-bottom-left-radius: 40px;
    padding: 30px;
    padding-top: 70px;
  }
  .profileHeader {
    border-top-left-radius: 0px;
  }
  .mainBody {
    border-bottom-left-radius: 0px;
  }
}
</style>
